import React from 'react';

// Common event handlers for nodes
export const handleEventPropagation = {
  stop: (e: React.SyntheticEvent) => {
    e.stopPropagation();
  },

  stopPreventDefault: (e: React.SyntheticEvent) => {
    e.stopPropagation();
    if ('preventDefault' in e) {
      e.preventDefault();
    }
  },

  keyboardSelect: (e: React.KeyboardEvent, action: () => void) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      action();
    }
  },
};

// Common node action handling
export const createActionHandler = (
  e: React.MouseEvent<HTMLElement>,
  action: () => void,
) => {
  e.stopPropagation();
  e.preventDefault();
  action();
};

// Determines if a click is on a specific class
export const isClickOnElement = (
  e: React.MouseEvent,
  className: string,
): boolean => {
  return !!(e.target as HTMLElement).closest(`.${className}`);
};
